import React, {useEffect, useState} from 'react';
import IconTitleValue from "components/textValue/IconTitleValue";
import getDateString from "components/utils/DateUtility";
import {callApi} from "../../../connection/ClientApi";
import Space from "../../../components/space/Space";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import TitleAddHeader from "../address/TitleAddHeader";
import DialogMessage from "components/dialogMessage/DialogMessage";
import {useHistory} from "react-router-dom";
import {groupedList} from "components/utils/ListUtility";
import OrderProduct from "./OrderProduct";
import getColorByOrderStatus from "./OrderUtility";
import {IsF, IsLP_MP, IsLP_MP_SP, IsLP_MP_SP_T, IsSP, IsT} from "my-styles/media/media";
import OrderTransaction from "./OrderTransaction";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import messages from "res/messages/farsi";
import Urls from "../../../connection/Urls";

import ICExpand from '@mui/icons-material/KeyboardArrowDown';
import ICLocation from "@material-ui/icons/MyLocation";
import ICEnvironmentSupporter from "res/images/environment_supporter.png";
import ICCalender from "res/images/calendar.png";
import ICAddress from "res/images/address.png";
import ICRole from "res/images/role.png";
import ICPayment from "res/images/payment.png";
import ICStatus from "res/images/done.png";
import ICEdit from "res/images/edit_white.png";
import ICDelete from "res/images/delete_white.png";
import ICBackIcon from "res/images/back.png";
import ICDone from "res/images/done_white.png";
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

export default function OrderDetail(props) {

    const history = useHistory()

    const [isCancelled, setIsCancelled] = useState(false)
    const [order, setOrder] = useState()
    const [products, setProducts] = useState()
    const [deleteOrderDialogShowStatus, setDeleteOrderDialogShowStatus] = useState(false)
    const [editOrderDialogShowStatus, setEditOrderDialogShowStatus] = useState(false)
    const [completeOrderDialogShowStatus, setCompleteOrderDialogShowStatus] = useState(false)
    const [showTransactionHistory, setShowTransactionHistory] = useState(false)

    const onEdit = () => {
        setEditOrderDialogShowStatus(true)
    }
    const onCancel = () => {
        setDeleteOrderDialogShowStatus(true)
    }
    const onCompleteOrder = () => {
        setCompleteOrderDialogShowStatus(true)
    }
    const onLocation = () => {
        props.onNavigate(history, '/driverLocation?id=' + order.order_id)
    }

    function requestOrderDetail() {
        let order_id = (props.location.state ? props.location.state.order_id : undefined)
        let params = new FormData()
        params.append("order_id", order_id)
        callApi(Urls.getOrderDetail, params, (data) => {
            if (isCancelled) return

            if (data && data.data) {
                setOrder(data.data)
                if (data.data.products) {
                    let constLimit = IsLP_MP() ? 3 : IsSP() ? 2 : 1
                    let emptyCount = constLimit - (data.data.products.length % constLimit)
                    setProducts(groupedList(data.data.products, constLimit, emptyCount))
                }
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestCancelOrder() {
        let params = new FormData()
        params.append("order_id", order.order_id)
        callApi(Urls.cancelOrder, params, () => {
            props.onAlert(messages.successCancelOrder, ALERT_TYPES.SUCCESS)
            props.onNavigate(history,
                '/orders?s=' + props.location.state.orderStatusId +
                "&p=" + props.location.state.page)
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestCompleteOrder() {
        let params = new FormData()
        params.append("order_id", order.order_id)
        callApi(Urls.completeOrder, params, () => {
            props.onNavigate(history, '/basket')
        }, (data) => {
            if (data.description === 103) {
                props.onAlert(messages.orderNotFound)
            } else if (data.description === 104) {
                props.onAlert(messages.orderCannotBeComplete)
            } else {
                props.onAlert(messages.responseCodeIsNot200)
            }
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestEditOrder(order) {
        let params = new FormData()
        params.append("order_id", order.order_id)
        callApi(Urls.editOrder, params, () => {
            props.onNavigate(history, '/basket')
        }, (data) => {
            if (data.description === 103) {
                props.onAlert(messages.orderNotFound)
            } else if (data.description === 104) {
                props.onAlert(messages.orderCannotBeEdit)
            } else {
                props.onAlert(messages.responseCodeIsNot200)
            }
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    useEffect(() => {
        requestOrderDetail()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<>{order &&
    <div className="wInLPT100_wInFMS95">
        <div className="marginTopBottomSmall">
            <TitleAddHeader
                icon={ICBackIcon}
                title={messages.myOrders}
                onIconClick={() => {
                    props.onNavigate(history,
                        '/orders?s=' + props.location.state.orderStatusId + "&p=" + props.location.state.page)
                }}/>
        </div>
        <div className="hInLPT_vInFMS">
            <div style={IsLP_MP_SP_T() ? {minHeight: "50em"} : {minHeight: "22em"}}
                 className="card marginLeftRightSmall wInLP32_wInT43_wInFMS100">
                <Space height={"1em"}/>
                <div
                    className={IsLP_MP_SP() ? "halfWidth" :
                        IsT() ? "twoFromThree" :
                            IsF() ? "twoFromThree" : "halfWidth"}>
                    <div className="card_blue_left_curve" style={{padding: "0.5px"}}>
                        <IconTitleValue
                            valueClassName={"whiteColor"}
                            titleClassName={"whiteColor"}
                            title={messages.orderNumber}
                            value={order.order_id}/>
                    </div>
                </div>
                {order.is_environment_supporter &&
                <img style={{position: "absolute", top: 0, left: 0}} src={ICEnvironmentSupporter} alt=""
                     className="mediumIcon marginSmall"/>
                }
                <Space height={"1em"}/>
                <IconTitleValue
                    valueClassName={getColorByOrderStatus(order.order_status_id) + " mediumTextBold "}
                    icon={<img src={ICStatus} alt="" className="xxSmallIcon"/>}
                    title={messages.orderStatus}
                    value={order.is_modified_by_system ? order.order_status + " " + messages.system : order.order_status}/>
                <IconTitleValue
                    icon={<img src={ICCalender} alt="" className="xxSmallIcon"/>}
                    title={messages.deliverDate}
                    value={getDateString(order.date_added) + " " + order.date_added_time}/>
                <IconTitleValue
                    icon={<FactCheckOutlinedIcon/>}
                    title={messages.totalFactorOrderPrice}
                    value={order.total}/>

                {order.products_discount_price > 0 &&
                <IconTitleValue
                    valueClassName="textRed mediumTextBold "
                    icon={<LocalOfferOutlinedIcon/>}
                    title={messages.productDiscount}
                    value={order.products_discount}/>
                }
                {order.excess_discount_price > 0 &&
                <IconTitleValue
                    valueClassName="textRed mediumTextBold "
                    icon={<LocalOfferOutlinedIcon/>}
                    title={messages.excessDiscount}
                    value={order.excess_discount}/>
                }
                {order.reward_discount_price > 0 &&
                <IconTitleValue
                    valueClassName="textRed mediumTextBold "
                    icon={<LocalOfferOutlinedIcon/>}
                    title={messages.specialDiscount}
                    value={order.reward_discount}/>
                }
                {order.total_used_wallet_price > 0 &&
                <IconTitleValue
                    valueClassName="textRed mediumTextBold "
                    icon={<AccountBalanceWalletOutlinedIcon/>}
                    title={messages.wallet}
                    value={order.total_used_wallet}/>}
                <IconTitleValue
                    icon={<LocalShippingOutlinedIcon/>}
                    title={messages.transportationCost}
                    value={(order.transportation_cost_price && order.transportation_cost_price > 0) ? order.transportation_cost : messages.free}/>
                <div className="horizontalFullScreen">
                    <div style={{width: "100%"}}>
                        <IconTitleValue
                            icon={<img src={ICPayment} alt="" className="xxSmallIcon"/>}
                            title={messages.paymentType}
                            value={order.payment_type_txt}/>
                    </div>
                    {order.transactions && order.transactions.length > 0 && order.payment_type === "1" &&
                    <IconTitleValue
                        flip={true}
                        titleClassName="greenColor"
                        icon={<ICExpand className="xxSmallIcon greenColor"/>}
                        title={messages.transactionHistory}
                        onClick={() => {
                            setShowTransactionHistory(!showTransactionHistory)
                        }}/>
                    }
                </div>
                {showTransactionHistory &&
                <div className="marginLeftRightMedium card">
                    {order.transactions.map((transaction, index) => {
                        return <OrderTransaction
                            key={index}
                            {...props} transaction={transaction}
                            showDivider={order.transactions.length - 1 > index}/>
                    })}
                </div>
                }
                <IconTitleValue
                    icon={<img src={ICRole} alt="" className="xxSmallIcon"/>}
                    title={messages.productCount}
                    value={order.count_products}/>
                <IconTitleValue
                    icon={<img src={ICAddress} alt="" className="xxSmallIcon"/>}
                    title={messages.deliverAddress}
                    value={order.address}/>
                <Space/>
                <div style={{float: "left"}}
                     className={IsLP_MP_SP() ? "halfWidth" :
                         IsT() ? "twoFromThree" :
                             IsF() ? "twoFromThree" : "halfWidth"}>
                    <div style={{padding: "0.5px"}}
                         className="card_pink_right_curve marginTopBottomSmall fullWidth">
                        <IconTitleValue
                            valueClassName={"whiteColor"}
                            titleClassName={"whiteColor"}
                            title={messages.totalOrderPriceNew}
                            value={order.net_total}/>
                    </div>
                </div>
                <div className="horizontalFullScreen marginTopSmall">
                    {order.allow_edit && order.allow_edit !== 'false' &&
                    <div className="marginSmall">
                        <IconTitleButtonRound
                            height={"2.7em"}
                            direction="ltr"
                            fontSize="smallTextBold"
                            title={messages.editOrder}
                            icon={<img className="xxSmallIcon" src={ICEdit} alt=""/>}
                            onClick={onEdit}/>
                    </div>
                    }
                    {order.allow_delete &&
                    <div className="marginSmall">
                        <IconTitleButtonRound
                            height={"2.7em"}
                            direction="ltr"
                            fontSize="smallTextBold"
                            title={messages.cancelOrder}
                            icon={<img className="xxSmallIcon" src={ICDelete} alt=""/>}
                            onClick={onCancel}/>
                    </div>
                    }
                    {order.allow_on_map &&
                    <div className="marginSmall">
                        <IconTitleButtonRound
                            height={"2.7em"}
                            direction="ltr"
                            fontSize="smallTextBold"
                            title={messages.peykLocation}
                            icon={<ICLocation className={'whiteColor'} fontSize={"small"}/>}
                            onClick={onLocation}/>
                    </div>
                    }
                    {order.allow_proccess &&
                    <div className="marginSmall">
                        <IconTitleButtonRound
                            height={"2.7em"}
                            direction="ltr"
                            fontSize="smallTextBold"
                            title={messages.completeOrder}
                            icon={<img className="xxSmallIcon" src={ICDone} alt=""/>}
                            onClick={onCompleteOrder}/>
                    </div>
                    }
                </div>
                {order.reserve_to.length > 0 &&
                <div style={{padding: 5}}
                     className="marginMedium redColor mediumTextBold center border_gray">
                    {order.reserve_to}
                </div>
                }
            </div>
            {products &&
            <div className="wInLP75_wInT45_wInFMS100 marginRightSmall">
                {products.map((productGroup, index) => {
                    return (<div key={index} className="horizontalFullScreen">
                        {productGroup.map((product, index) => {
                            return <OrderProduct key={index} {...props} product={product}/>
                        })}
                    </div>)
                })}
            </div>
            }
        </div>
        <DialogMessage
            showStatus={deleteOrderDialogShowStatus}
            title={messages.cancelOrder}
            message={messages.sureCancelOrder}
            submitTitle={messages.yes}
            closeTitle={messages.no}
            onCloseClicked={() => {
                setDeleteOrderDialogShowStatus(false)
            }}
            onSubmitClicked={() => {
                setDeleteOrderDialogShowStatus(false)
                requestCancelOrder(order)
            }}
        />
        <DialogMessage
            showStatus={completeOrderDialogShowStatus}
            title={messages.completeOrder}
            message={messages.sureCompleteOrder}
            submitTitle={messages.yes}
            closeTitle={messages.no}
            onCloseClicked={() => {
                setCompleteOrderDialogShowStatus(false)
            }}
            onSubmitClicked={() => {
                setCompleteOrderDialogShowStatus(false)
                requestCompleteOrder(order)
            }}
        />
        <DialogMessage
            showStatus={editOrderDialogShowStatus}
            title={messages.editOrder}
            message={messages.sureEditOrder}
            submitTitle={messages.yes}
            closeTitle={messages.no}
            onCloseClicked={() => {
                setEditOrderDialogShowStatus(false)
            }}
            onSubmitClicked={() => {
                setEditOrderDialogShowStatus(false)
                requestEditOrder(order)
            }}
        />
    </div>
    }</>)

}